module.exports = __webpack_public_path__ + "static/Utah-Gymnastics-652c040213d09747cd6de396b818158f.jpg";